<template>
  <a @click="selectDate" :class="{
    disabled: disabled,
    placeholder: date === undefined || day === '',
    selected: $store.state.selectedDate === date,
  }">
    <span>{{ day }}</span>
  </a>
</template>

<script>
  import axios from "axios";
  export default {
    name: "Day",
    props: {
      date: String,
      day: String,
      disabled: Boolean,
    },
    methods: {
      selectDate() {
        this.$store.commit("setSelectedBooking", '');
        this.$store.commit("setSelectedDate", this.date);
        const params = new URLSearchParams();
        params.append("date", this.date);
        params.append("schedule", this.$store.state.selectedSchedule);
        axios
          .post(`${this.$store.state.API}/Bookings.php`, params)
          .then(this.onGetBookings);
      },
      scrollToHash() {
        const element = document.querySelector('#available-times');
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      },
      onGetBookings(response) {
        if (response.data.status == "ok") {
          this.$store.commit("setAvailableBookings", response.data['json-content']);
          setTimeout(this.scrollToHash, 1)
        } else {
          this.$store.commit("setSelectedDate", "");
          alert("An error occurred getting the bookings");
        }
      },
    },
  };
</script>

<style lang="scss" scoped>
  a {
    cursor: pointer;
    user-select: none;
    display: grid;
    place-items: center;
    width: 40px;
    height: 40px;
    color: var(--black);
    transition: all 0.2s ease-out;

    span {
      text-align: center;

      font-family: "proxima-nova", sans-serif;
      font-size: 16px;
      font-weight: 600;
      letter-spacing: 0.32px;
      text-transform: uppercase;
    }

    &.disabled {
      pointer-events: none;
    }

    &:not(.disabled) {
      border-radius: 52px;
      border: 1px solid var(--black);
      background: var(--white);

      @media (hover:hover) {
        &:hover {
          background: var(--green);
          color: var(--white);
        }
      }
    }

    &.selected {
      background: var(--green);
      color: var(--white);
    }
  }
</style>